<script>
	import Hero from '$lib/components/Hero.svelte';
	import Masters from '$lib/components/Masters.svelte';
	import Quiz from '$lib/components/Quiz.svelte';
	import logo from '$lib/assets/images/logo.svg';
	import QuizPopup from '$lib/components/QuizPopup.svelte';
	import { formOpen, quizOpen } from '$lib/index.svelte';
	import FormPopup from '$lib/components/FormPopup.svelte';
</script>

<Hero />
<Masters />
<Quiz />

{#if quizOpen.status}
	<QuizPopup />
{/if}

{#if formOpen.status}
	<FormPopup />
{/if}

<footer class="pt-50 pb-20">
	<div class="flex flex-col items-center justify-center gap-5">
		<img loading="lazy" class="w-40" src={logo} alt="mifroma's Logo" />
		<p class="text-center">
			Your Maître Fromager is more than a guide, they’re your connection to the world of Mifroma.
		</p>
	</div>
</footer>
